<template lang="pug">
  .row.width-100.min-view-height.center.middle
    choice-modal(v-if='showChoiceModal')
    token-error(
      :title='$t("token.expiredTokenTitle")'
      :expired='true'
      :userId='userId'
      :schoolId='schoolId'
    )
</template>

<script>
import TokenError from '@/components/TokenError'
import ChoiceModal from '@/components/Modals/ChoiceModal'
import CustomToast from '../components/CustomToast'
import { mapState } from 'vuex'

export default {
  name: 'ExpiredToken',
  props: {
    userId: { type: String },
    schoolId: { type: Number }
  },
  components: { TokenError, ChoiceModal, CustomToast },
  computed: {
    ...mapState({
      showChoiceModal: state => state.behavior.choiceModal.show
    }),
    toastStyles() {
      return {
        width: '100%',
        display: 'flex',
        left: '0',
        'justify-content': 'center'
      }
    }
  }
}
</script>
